export default "__VITE_ASSET__Bgz3roMR__"